import React from 'react';
import { AmplifyCore } from '@codametrix/ui-common';
import classnames from 'classnames';
import { cmxDateTime } from '@codametrix/ui-common';
import { getCellData, getSubmittedInvoiceCodes, prop } from '../related-cases/related-cases.utilities';
import './styles/index.scss';
const { benchEditable: benchEditableCore } = AmplifyCore;

export type CaseCardProps = {
  caseData: CMxCommonApp.RelatedCaseExtended;
  isCurrent?: boolean;
  currentCaseTenantCode: string;
  currentCaseTenantName: string;
  onCaseClick: (relatedCase: CMxCommonApp.RelatedCaseExtended) => void;
  showProviderInfo: (providerInfo: CMxCommonApp.ProviderSearchParams) => void;
};

export const CaseCard: React.FC<CaseCardProps> = (props: CaseCardProps) => {
  const {
    caseData,
    isCurrent,
    currentCaseTenantCode,
    currentCaseTenantName,
    onCaseClick
  } = props;

  const ProcessStatus = () => {
    const styleClasses = benchEditableCore.fecthProcessStatusClasses(
      caseData?.processStatus,
      caseData?.coding_status?.hold_status
    );
    const status = prop(caseData, 'processStatus');
    const celldata = getCellData(status, false);
    return (
      <span className="head process-status-container">
        <span className={classnames(styleClasses)}>{celldata}</span>
      </span>
    );
  };

  const SubmittedInvoiceCodes = () => {
    const status = prop(caseData, 'processStatus');
    const invoices = prop(caseData,'invoices');
    const celldata = getSubmittedInvoiceCodes(status,invoices);
    if (!celldata) return null;
      return celldata;
  };

  const DateOfService = () => {
    const dateOfService = prop(caseData, 'date_of_service');
    return <span className="head date-of-service">{dateOfService}</span>;
  };

  const PatientClass = () => {
    const patientClass = prop(caseData, 'patient_class');
    return getCellData(patientClass, true, ['head', 'patient-class']);
  };

  const CaseId = () => {
    const case_id = `#${prop(caseData, 'case_id', '')}`;
    return getCellData(case_id, true, ['case-id', 'cmx-link']);
  };

  const NoteSpecialty = () => {
    const noteSpecialtyDesignation = prop(
      caseData,
      'note_specialty_designation'
    );
    return getCellData(noteSpecialtyDesignation, true, ['note-specialty']);
  };

  const FinalSignProvider = () => {
    const providerName = prop(caseData, 'note_final_sign_provider_name');
    return (
      <span
        onClick={ev => {
          ev.preventDefault();
          props.showProviderInfo({
            providerName: caseData?.note_final_sign_provider_name,
            providerNumber: caseData?.note_final_sign_provider_number,
            tenantCode: currentCaseTenantCode
          });
        }}>
        {getCellData(providerName, false, ['cmx-link', 'final-sign-provider'])}
      </span>
    );
  };
  const AuthoringProvider = () => {
    const providerName = prop(caseData, 'primary_activity_provider_name');
    return (
      <span
        onClick={ev => {
          ev.preventDefault();
          props.showProviderInfo({
            providerNumber: caseData?.primary_activity_provider_number || '',
            providerName: caseData?.primary_activity_provider_name || '',
            tenantCode: currentCaseTenantCode
          });
        }}>
        {getCellData(providerName, false, ['cmx-link', 'authoring-provider'])}
      </span>
    );
  };
  const TimeOfService = () => {
    const timeOfService = caseData?.datetime_of_service
      ? cmxDateTime.format(
          cmxDateTime.wrapTimezoneInBracket(caseData.datetime_of_service),
          cmxDateTime.FORMATS.TIME_WITHOUT_SECONDS
        )
      : '';
    return <span className="time-of-service">{timeOfService}</span>;
  };

  const NoteDescription = () => {
    return (
      <span className="note-description">
        {caseData?.notes?.map((note, idx) => (
          <span key={idx}>{note?.description}</span>
        ))}
      </span>
    );
  };

  return (
    <div className={`case-card ${isCurrent ? 'current-case' : ''}`}>
      <div className="cmx-card-header">
        <DateOfService />
        <PatientClass />
        <span className="case-link head" onClick={() => onCaseClick(caseData)}>
          <CaseId />
        </span>
        <ProcessStatus />
      </div>
      <div className="cmx-card-body">
        <div className="card-left">
          <NoteSpecialty />
          <NoteDescription />
          <TimeOfService />
        </div>
        <div className="card-right">
          <div className="provider-detail">
            <span className="provider-type">FINAL SIGNING PROVIDER</span>
            <FinalSignProvider />
          </div>
          <div className="provider-detail">
            <span className="provider-type">AUTHORING PROVIDER</span>
            <AuthoringProvider />
          </div>
        </div>
      </div>
      <SubmittedInvoiceCodes/>   
    </div>
  );
};

CaseCard.displayName = 'CaseCard';
